var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupedit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#38B000",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#38B000",
    strokeOpacity: 0.05,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 24H22C21.4696 24 20.9609 24.2107 20.5858 24.5858C20.2107 24.9609 20 25.4696 20 26V35C20 35.5304 20.2107 36.0391 20.5858 36.4142C20.9609 36.7893 21.4696 37 22 37H31C31.5304 37 32.0391 36.7893 32.4142 36.4142C32.7893 36.0391 33 35.5304 33 35V34",
    stroke: "#38B000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22.0001L35 25.0001M36.385 23.5851C36.7788 23.1913 37.0001 22.6571 37.0001 22.1001C37.0001 21.5431 36.7788 21.009 36.385 20.6151C35.9912 20.2213 35.457 20 34.9 20C34.343 20 33.8088 20.2213 33.415 20.6151L25 29.0001V32.0001H28L36.385 23.5851Z",
    stroke: "#38B000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupedit);
export default __webpack_public_path__ + "static/media/popupedit.d0b823d84d80d9926d1125edc4fd4763.svg";
export { ForwardRef as ReactComponent };